import { useLang } from "@/lib/i18n";
import { useReveal } from "@/lib/useReveal";

export const Services = () => {
  const { t } = useLang();
  const { ref, visible } = useReveal();
  return (
    <section
      id="services"
      data-testid="services-section"
      ref={ref}
      className={`py-20 md:py-32 bg-white border-y border-neutral-200 reveal-up ${visible ? "in-view" : ""}`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-y-8 lg:gap-x-12 mb-16 md:mb-24">
          <div className="col-span-12 lg:col-span-4">
            <div className="overline mb-6">{t.services.overline}</div>
          </div>
          <h2 className="col-span-12 lg:col-span-8 editorial-h text-4xl md:text-5xl lg:text-6xl whitespace-pre-line">
            {t.services.title}
          </h2>
        </div>

        <div className="border-t border-neutral-300">
          {t.services.list.map((s, i) => (
            <div
              key={i}
              data-testid={`service-${i}`}
              className="group border-b border-neutral-300 py-8 md:py-10 grid grid-cols-12 gap-y-3 lg:gap-x-12 items-start hover:bg-neutral-50/60 transition-colors px-1 -mx-1"
            >
              <div className="col-span-3 md:col-span-2 lg:col-span-1 font-mono text-xs text-neutral-500 pt-1">
                {s.n}
              </div>
              <div className="col-span-9 md:col-span-10 lg:col-span-4">
                <h3 className="font-serif text-3xl md:text-4xl tracking-tight">
                  {s.name}
                </h3>
              </div>
              <div className="col-span-12 lg:col-span-6 lg:col-start-7">
                <p className="text-[15px] md:text-base leading-relaxed text-neutral-600 max-w-xl">
                  {s.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
